import React, { useContext, useState, useEffect, useRef } from 'react';
import {Table, Input, Button, Form, Space, message, Modal, Col, Select, Row, DatePicker, Upload, Spin} from 'antd';
import {dispute_approval, dispute_approval_item, uploadAttachment} from "../../../requist";
import {Option} from "antd/es/mentions";
import TextArea from "antd/es/input/TextArea";
import {UploadOutlined} from "@ant-design/icons";

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
let file_list = []
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const selectRef = useRef(null);
    const uploadRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            if(dataIndex==='approveType'){
                selectRef.current.focus()
            }else if(dataIndex==='attachment'){
                uploadRef.current.fileList=[]
                console.log(uploadRef.current.fileList)
                // uploadRef.current.upload.saveUploader()
                uploadRef.current.upload.props.onStart()
            }else{
                inputRef.current.focus();
            }

        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;
    let fileProps = {
        name: 'file',
        maxCount:1,
        showUploadList:false,
        async beforeUpload(file, fileList) {
            file_list = fileList[0]
            // console.log(fileList[0])
            if (fileList[0].size / 1024 / 1024 > 10) { // 上传的文件大于10M
                message.warning('The uploaded file size exceeds 10MB!');
                return Upload.LIST_IGNORE
            }
            const res = await uploadAttachment(fileList[0]);
            if (res.retCode === '200') {
                message.success('File uploaded successfully!');
                fileList[0].data = {s3FileName: res.data};
                return false;
            } else {
                message.error(`${res.retMsg}`)
                return Upload.LIST_IGNORE
            }
            return false
        },
    };
    const normFile = (e: any) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        // required: dataIndex==='approveType'?true:false,
                        // message: `${title} is required.`,
                    },
                ]}
            >
                {dataIndex === 'approveType' ?
                    <Select ref={selectRef} onChange={save} onBlur={save}>
                        <Option value={"1"}>With credit / debit note</Option>
                        <Option value={"2"}>With offline process</Option>
                        <Option value={"3"}>With mass tool</Option>
                    </Select>
                    :
                    dataIndex === 'attachment' ?
                        <Form.Item fieldKey={Math.random()}>
                            <Form.Item name="dragger" {...fileProps} valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                <Upload ref={uploadRef} {...fileProps} onBlur={save} onChange={save} name="files" action="/upload.do">
                                    {/*<p className="ant-upload-text">Click or drag file to this area to upload</p>*/}
                                    {/*<p className="ant-upload-hint">Support for a single or bulk upload.</p>*/}
                                    <Button  icon={<UploadOutlined />}>Upload</Button>
                                </Upload>
                            </Form.Item>
                        </Form.Item>:
                        // <Upload ref={uploadRef} {...fileProps} onBlur={save} onChange={save}>
                        //     <Button  icon={<UploadOutlined />}>Upload</Button>
                        // </Upload>
                    dataIndex === 'approveComments' ?
                        <Input maxLength={255} ref={inputRef} onPressEnter={save} onBlur={save}/>
                    :
                    <Input style={{width: 200}} ref={inputRef} onPressEnter={save} onBlur={save}/>
                }
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};

class DisputeApprovalTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count:null,
            selectedRowKeys:[],
            dataSource: this.props.dataSource,
            rejectStatus:true,
            approveStatus:true,
            offlineApprove:true,
            isModalVisible:false,
            detailData:[],
            selectedRows:[],
            loading:false,
            disputeType:null,
        };
        this.columns = [
            {
                title: 'Dispute Type',
                dataIndex: 'disputeTypeText',
                width: 250,
            },
            {
                title: 'Dispute No',
                dataIndex: 'disputeNo',
                width: 250,
                render:((text)=>{
                    return <a onClick={()=>{
                        dispute_approval_item(text).then(res=>{
                            const {data} = res;
                            if(res.retCode==='200'){
                                this.setState({detailData:data,disputeType:data.disputeType})
                                this.setState({isModalVisible:true})
                            }
                        })
                    }
                    }>{text}</a>
                })
            },
            {
                title: 'Dispute Status',
                dataIndex: 'statusText',
                width: 250,
            },
            {
                title: 'Offline Approved',
                dataIndex: 'offlineApproved',
                width: 250,
            },
            {
                title: 'Sold to',
                dataIndex: 'soldTo',
                width: 250,
            },
            {
                title: 'Sold to Name',
                dataIndex: 'soldToName',
                width: 250,
            },
            {
                title: 'Dispute Amount Total (All item amount total)',
                dataIndex: 'totalAmount',
                width: 250,
            },
            {
                title: 'Approval Type',
                dataIndex: 'approveType',
                editable: true,
                width: 250,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else {
                        if(text==="1"){
                            return 'With credit / debit note'
                        }else if(text==="2"){
                            return  'With offline process'
                        }else if(text==="3"){
                            return 'With mass tool'
                        }else{
                            return 'Please select'
                        }
                    }
                }
            },
            {
                title: 'Comments (the field is mandatory for reject)',
                dataIndex: 'approveComments',
                editable: true,
                width: 250,
                render:(text, record, index)=>{
                    record.approveComments=text
                    if(!text){
                        return <Input style={{width:200}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Attachment Upload',
                dataIndex: 'attachment',
                editable: true,
                width: 250,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Upload'
                    }else {
                        return <Upload fileList={text}>
                            {/*<Button icon={<UploadOutlined />}>Upload</Button>*/}
                        </Upload>
                        // if(text.length){
                        //     return text[0].name
                        // }else{
                        //     return text.name
                        // }

                    }
                }
            },
            // {
            //     title: 'Financial Claim Request No',
            //     dataIndex: 'requestNo',
            // },
            {
                title: 'status',
                dataIndex: 'status',
                width: 250,
            },
            {
                title: 'disputeType',
                dataIndex: 'disputeType',
                width: 250,
            },
            {
                title: 'Create At',
                dataIndex: 'createdAt',
                width: 250,
            },
            {
                title: 'Requestor',
                dataIndex: 'requesterId',
                width: 250,
                render:(text,record)=>{
                    if(text){
                        return text
                    }else{
                        return record.createdBy
                    }
                }
            },
        ];
        this.columns_detail=[
            {
                title: 'Invoice NO',
                dataIndex: 'invoiceNo',
                width: 250,
            },
            {
                title: 'Invoice Item NO',
                dataIndex: 'invoiceItemNo',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'PO Number',
                dataIndex: 'poNumber',
                width: 250,
            },
            {
                title: 'Delivery Number',
                dataIndex: 'deliveryNumber',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Order Number',
                dataIndex: 'orderNumber',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Part Number',
                dataIndex: 'partNumber',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Credit Amount Per Unit',
                dataIndex: 'creditAmountUnit',
                width: 250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Credit Amount Total',
                dataIndex: 'creditAmountTotal',
                width: 250,
            },
            {
                title: 'Currency',
                dataIndex: 'currency',
                width: 250,
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNumbers',
                width: 250,
            },
            {
                title: 'Bill To',
                dataIndex: 'billTo',
                width: 250,
            },
            {
                title: 'Bill To Name',
                dataIndex: 'billToName',
                width: 250,
            },
            {
                title: 'Ship To',
                dataIndex: 'shipTo',
                width: 250,
            },
            {
                title: 'Ship To Name',
                dataIndex: 'shipToName',
                width: 250,
            },
        ]
        this.columns_backend_detail=[
            {
                title: 'BP customer number(sold to)',
                dataIndex: 'soldTo',
            },
            {
                title: 'BP Name',
                dataIndex: 'soldToName',
            },
            {
                title: 'Claimed Amount',
                dataIndex: 'creditAmountTotal',
            },
            {
                title: 'Currency',
                dataIndex: 'currency',
            },
            {
                title: 'Type',
                dataIndex: 'backendType',
                render:(text,record)=>{
                    if(text){
                        return 'Growth Investment (GI / BDP) Claim'
                    }
                }
            },
            {
                title: 'GI Agreement No.',
                dataIndex: 'bdpGiNo',
            },
            {
                title: 'Period/Quarter',
                dataIndex: 'period',
            },
        ]
        this.columns =  this.columns.filter((v)=>{
            return v.dataIndex !== 'status' && v.dataIndex !== 'disputeType';
        });
    }
    handleSave = (row) => {
        let newRow;
        // if(row.attachment && row.attachment.fileList){
        //     newRow = {...row,attachment:row.attachment.fileList[0].originFileObj}
        // }else{
        //     if(row.attachment){
        //         newRow = {...row,attachment:row.attachment}
        //     }else{
        //         newRow = row;
        //     }
        // }
        if(row.file&& row.file.fileList){
            newRow = {...row,attachment:row.file[0].data.s3FileName}
        }else{
            if(row.file){
                newRow = {...row,attachment:row.file}
            }else{
                newRow = row;
            }
        }
        // let newRow = {...row,attachment:row.attachment.fileList?row.attachment.fileList[0].originFileObj:row.attachment && !row.attachment.fileList?row.attachment:''}
        const newData = [...this.state.dataSource.length?this.state.dataSource:this.props.dataSource];
        const index = newData.findIndex((item) => newRow.disputeNo === item.disputeNo);
        const item = newData[index];
        let {selectedRows}=this.state;
        let newRows=[];
        selectedRows.map(item=>{
            if(item.id==newRow.id){

            }else{
                newRows.push(item)
            }
        })
        newData.splice(index, 1, { ...item, ...newRow });
        // console.log([...newRows,row])
        this.setState({
            dataSource: newData,
            selectedRows:[...newRows,newRow]
        });
    };
    onSelectChange = (selectedRowKeys,selectedRows) => {
        if(!selectedRows.length){
            this.setState({rejectStatus:false})
        }
        let DWFOA=0,DWAAP=0
        selectedRows.every( item => {
            if(item.attachment && item.attachment.fileList){
                item.attachment = item.attachment.fileList[0].data.s3FileName
            }
            if(item.status=="DWFOA"){
                ++DWFOA
                this.setState({offlineApprove:DWAAP?true:false,rejectStatus:false})
                return true
            }else if(item.status=="DWAAP"){
                ++DWAAP
                this.setState({approveStatus:DWFOA?true:false,rejectStatus:false})
                return true
            }else{
                this.setState({approveStatus:true,rejectStatus:true,offlineApprove:true})
                return false
            }
        });
        if(!selectedRowKeys.length){
            this.setState({approveStatus:true,offlineApprove:true,rejectStatus:true})
        }
        this.setState({ selectedRowKeys:selectedRowKeys,selectedRows:selectedRows});
    };
    onApprove=()=>{
        const {selectedRows,dataSource} = this.state
        let approveType=true;
        let attachment=true;
        this.setState({loading:true})
        let data = new FormData();
        let userId = window.localStorage.getItem('userId')
        selectedRows.map( (item,index) => {
            if(item.attachment && item.attachment.length){
                item.attachment = item.attachment[0].data.s3FileName
            }else {
                item.attachment=null
            }
            if(!item.approveType){
                approveType=false
                return false
            }else{
                if(item.approveType==="1" || item.approveType==="3"){
                        if(item.attachment){

                        }else{
                            if(item.disputeType==='SESC' || item.disputeType==='CBSO' || item.disputeType==='EDSRR' || item.disputeType==='EPSRR'){

                            }else{
                                attachment=false
                                return false
                            }
                        }
                }
                for(let IK in item){
                    if(`${IK}`==='items'){
                        item[IK].length && item[IK].map((item_data,item_index)=>{
                            for(let itemsK in item_data){
                                if(item_data[itemsK]){
                                    data.append(`data[${index}].${IK}[${item_index}].${itemsK}`,item_data[itemsK])
                                }
                            }
                        })
                    }else{
                        if(item[IK]){
                            if(IK==='changedAt' || IK==='approvedAt'){

                            }else{
                                if(IK==='attachment' && item[IK]==null){

                                }else{
                                    data.append(`data[${index}].${IK}`,item[IK])
                                }
                            }
                        }
                    }
                }
            }
        });
        if(selectedRows.length && approveType){
            data.append('userId',userId)
            data.append('action',1)
            if(attachment){
                dispute_approval(1,data).then((res)=>{
                    const {retCode,data,retMsg} = res
                    if(retCode==="200"){
                        let newData;
                        data.forEach((item)=>{
                            dataSource.forEach((item_d,i)=>{
                                if(item.id==item_d.id){
                                    dataSource.splice(i,1)
                                }
                            })
                        })
                        newData = data.concat(dataSource)
                        this.setState({
                            selectedRowKeys:[],
                            selectedRows:[],
                            loading:false,
                            approveStatus:true,
                            rejectStatus:true,
                            offlineApprove:true,
                            dataSource:newData.sort((a, b) => {
                                return b.value - a.value
                            })})
                        message.success(`${retMsg}`)
                    }else{
                        message.warn(`${retMsg}`)
                        this.setState({loading:false})
                    }
                })
            }else{
                message.warn('Attachment is required')
                this.setState({loading:false})
            }
        }else{
            message.warn('Please firstly input approveType')
            this.setState({loading:false})
        }

    }
    onReject=()=>{
        const {selectedRows,dataSource} = this.state
        let comments=true;
        let attachment=true;
        this.setState({loading:true})
        let data = new FormData();
        let userId = window.localStorage.getItem('userId')
        selectedRows.map( (item,index) => {
            if(item.attachment && item.attachment.length){
                item.attachment = item.attachment[0].data.s3FileName
            }else {
                item.attachment=null
            }
            if(!item.approveComments){
                comments=false
                return false
            }else{
                if(item.approveType==="1" || item.approveType==="3"){
                    if(item.attachment){

                    }else{
                        if(item.disputeType==='SESC' || item.disputeType==='CBSO' || item.disputeType==='EDSRR' || item.disputeType==='EPSRR'){

                        }else{
                            attachment=false
                            return false
                        }
                    }
                }
                for(let IK in item){
                    if(`${IK}`==='items'){
                        item[IK].length && item[IK].map((item_data,item_index)=>{
                            for(let itemsK in item_data){
                                data.append(`data[${index}].${IK}[${item_index}].${itemsK}`,item_data[itemsK])
                            }
                        })
                    }else{
                        if(item[IK]){
                            if(IK==='changedAt' || IK==='approvedAt'){

                            }else{
                                if(IK==='attachment' && item[IK]==null){

                                }else{
                                    data.append(`data[${index}].${IK}`,item[IK])
                                }
                            }
                        }
                    }
                }
            }
        });

        if(selectedRows.length && comments){
            data.append('userId',userId)
            data.append('action',2)
            if(attachment){
                dispute_approval(2,data).then((res)=>{
                    const {data}=res;
                    if(res.retCode==="200"){
                        let newData;
                        data.forEach((item)=>{
                            dataSource.forEach((item_d,i)=>{
                                if(item.id==item_d.id){
                                    dataSource.splice(i,1)
                                }
                            })
                        })
                        newData = data.concat(dataSource)
                        this.setState({
                            selectedRowKeys:[],
                            selectedRows:[],
                            loading:false,
                            approveStatus:true,
                            rejectStatus:true,
                            offlineApprove:true,
                            dataSource:newData.sort((a, b) => {
                                return b.value - a.value
                            })})
                        message.success(`${res.retMsg}`)
                    }else {
                        message.warn(`${res.retMsg}`)
                        this.setState({loading:false})
                    }
                })
            }else{
                message.warn('Attachment is required')
                this.setState({loading:false})
            }
        }else{
            message.warn('Please firstly input comments')
            this.setState({loading:false})
        }
    }

    onOfflineApprove=()=>{
        const {selectedRows,dataSource} = this.state
        let approveType=true;
        let attachment=true;
        this.setState({loading:true})
        let data = new FormData();
        let userId = window.localStorage.getItem('userId')
        selectedRows.map( (item,index) => {
            if(item.attachment && item.attachment.length){
                item.attachment = item.attachment[0].data.s3FileName
            }
            if(!item.approveType){
                approveType=false
                return false
            }else{
                if(item.approveType==="1" || item.approveType==="3"){
                    if(item.attachment){

                    }else{
                        if(item.disputeType==='SESC' || item.disputeType==='CBSO' || item.disputeType==='EDSRR' || item.disputeType==='EPSRR'){

                        }else{
                            attachment=false
                            return false
                        }
                    }
                }
                for(let IK in item){
                    if(`${IK}`==='items'){
                        item[IK].length && item[IK].map((item_data,item_index)=>{
                            for(let itemsK in item_data){
                                data.append(`data[${index}].${IK}[${item_index}].${itemsK}`,item_data[itemsK])
                            }
                        })
                    }else{
                        if(IK==='attachment' && item[IK]==null){

                        }else{
                            data.append(`data[${index}].${IK}`,item[IK])
                        }
                    }
                }
            }
        });

        if(selectedRows.length && approveType){
            data.append('userId',userId)
            data.append('action',3)
            if(attachment){
                dispute_approval(3,data).then((res)=>{
                    const {data}=res;
                    if(res.retCode==="200"){
                        let newData
                        data.forEach((item)=>{
                            dataSource.forEach((item_d,i)=>{
                                if(item.id==item_d.id){
                                    dataSource.splice(i,1)
                                }
                            })
                        })
                        newData = data.concat(dataSource)
                        this.setState({
                            selectedRowKeys:[],
                            selectedRows:[],
                            loading:false,
                            approveStatus:true,
                            rejectStatus:true,
                            offlineApprove:true,
                            dataSource:newData.sort((a, b) => {
                                return b.value - a.value
                            })})
                        message.success(`${res.retMsg}`)
                    }else{
                        message.warn(`${res.retMsg}`)
                        this.setState({loading:false})
                    }
                })
            }else{
                message.warn('Attachment is required')
                this.setState({loading:false})
            }
        }else{
            message.warn('Please firstly input comments')
            this.setState({loading:false})
        }
    }
    handleOk=()=>{
        this.setState({isModalVisible:false})
    }
    handleCancel=()=>{
        this.setState({isModalVisible:false})
    }
    componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any) {
        this.setState({dataSource:nextProps.dataSource})
    }

    render() {
        const { dataSource,selectedRowKeys,isModalVisible,detailData,loading} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            getCheckboxProps: (record: DataType) => ({
                disabled: record.status==="DAPPR" || record.status==="DREJE" || record.status==="DCLOS",
                name: record.name,
            }),
        };
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }

            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return (
            <div>
                <div className="example" style={{display:loading?'block':'none'}}>
                    <Spin spinning={loading} />
                </div>
                <Space style={{marginBottom:20}}>
                    <Button type="primary" onClick={this.onApprove} disabled={this.state.approveStatus}>
                        Approve
                    </Button>
                    <Button type="primary" onClick={this.onReject} disabled={this.state.rejectStatus}>
                        Reject
                    </Button>
                    <Button type="primary" onClick={this.onOfflineApprove} disabled={this.state.offlineApprove}>
                        Offline Approve
                    </Button>
                </Space>
                <Table
                    // style={{paddingRight:24}}
                    scroll={{y: 500}}
                    components={components}
                    rowKey={'id'}
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={dataSource}
                    columns={columns}
                    rowSelection={rowSelection}
                />
                {detailData?<Modal title="Dispute Detail"
                        width={1200}
                        visible={isModalVisible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        destroyOnClose={true}
                >
                    <Form
                        name="disputeDetail"
                        labelCol={{span: 10}}
                        wrapperCol={{span: 12}}
                        preserve={false}>
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute No"
                                    name="disputeNo"
                                    rules={[{required: false}]}
                                    initialValue={detailData.disputeNo}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Type"
                                    name="disputeTypeText"
                                    rules={[{required: false}]}
                                    initialValue={detailData.disputeTypeText}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Create At"
                                    name="createdOn"
                                    rules={[{required: false}]}
                                    initialValue={detailData.createdAt}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold to"
                                    name="soldTo"
                                    rules={[{required: false}]}
                                    initialValue={detailData.soldTo}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold To Name"
                                    name="soldToName"
                                    rules={[{required: false}]}
                                    initialValue={detailData.soldToName}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Sold To Country"
                                    name="soldToCountry"
                                    rules={[{required: false}]}
                                    initialValue={detailData.soldToCountry}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Requestor"
                                    name={'requesterId'}
                                    rules={[{required: false}]}
                                    initialValue={detailData.requesterId}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Dispute Status"
                                    name="statusText"
                                    rules={[{required: false}]}
                                    initialValue={detailData.statusText}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Customer Internal Ref"
                                    name="customerInternalRef"
                                    rules={[{required: false}]}
                                    initialValue={detailData.customerInternalRef}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Comments"
                                    name="comments"
                                    rules={[{required: false}]}
                                    initialValue={detailData.comments}
                                >
                                    <TextArea disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Requested Changes"
                                    name="requestedChanges"
                                    rules={[{required: false}]}
                                    initialValue={detailData.requestedChanges}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Request VAT ID"
                                    name="requestVatId"
                                    rules={[{required: false}]}
                                    initialValue={detailData.requestVatId}
                                >
                                    <Input disabled/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Table
                            style={{paddingRight: 24}}
                            scroll={{y: 500}}
                            // rowKey={'disputeNo'}
                            rowKey={'id'}
                            bordered
                            dataSource={detailData.items}
                            columns={detailData.disputeType==="BAKD"?this.columns_backend_detail:this.columns_detail}
                        />
                    </Form>
                </Modal>:null}
            </div>
        );
    }
}
export default DisputeApprovalTable;